import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
export const ChampIcon = t0 => {
  const $ = _c(9);
  const {
    size,
    championId,
    className
  } = t0;
  if (championId === undefined) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = {
        objectFit: "contain"
      };
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    let t2;
    if ($[1] !== className || $[2] !== size) {
      t2 = <Image alt="Champion Icon" width={size} height={size} className={className} style={t1} src="https://raw.communitydragon.org/latest/plugins/rcp-be-lol-game-data/global/default/v1/champion-icons/-1.png" />;
      $[1] = className;
      $[2] = size;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  let t1;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      objectFit: "contain"
    };
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const t2 = `https://raw.communitydragon.org/latest/plugins/rcp-be-lol-game-data/global/default/v1/champion-icons/${championId}.png`;
  let t3;
  if ($[5] !== className || $[6] !== size || $[7] !== t2) {
    t3 = <Image alt="Champion Icon" width={size} height={size} style={t1} className={className} src={t2} />;
    $[5] = className;
    $[6] = size;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};